import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/")({
    beforeLoad: () => {
        throw redirect({ to: "/customers/success", replace: true });
    },
});
